'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseMenuItem = function BaseMenuItem(_ref) {
  var href = _ref.href,
      role = _ref.role,
      tabIndex = _ref.tabIndex,
      onClick = _ref.onClick,
      newWindow = _ref.newWindow,
      children = _ref.children;
  return _react2.default.createElement(
    'a',
    {
      className: 'quiver-base-menu-item',
      href: href,
      role: role,
      tabIndex: tabIndex,
      onClick: onClick,
      target: newWindow ? '_blank' : ''
    },
    children
  );
};

BaseMenuItem.propTypes = {
  href: _propTypes2.default.string,
  role: _propTypes2.default.string,
  tabIndex: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  newWindow: _propTypes2.default.bool,
  children: _propTypes2.default.node.isRequired
};

BaseMenuItem.defaultProps = {
  href: null,
  role: null,
  tabIndex: null,
  onClick: null,
  newWindow: false
};

exports.default = BaseMenuItem;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/BaseMenuItem/BaseMenuItem.js
// module id = 265
// module chunks = 0